// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // API_URL:'http://api.ubsols.com/ServiceUbsols.svc',
   //API_URL:'https://api-ubsols-spino.schoolconnect.me/ServiceUbsols.svc',
   API_URL:'https://live.api.ubsols.com/ServiceUbsols.svc',
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
